import React from 'react';
import pluralize from 'pluralize';

import routes from 'js/core_pre_webpack/routes';
import Unibrow from 'js/design_system/Unibrow';
import InfoIcon from 'js/design_system/icons/info.svg';
import WarningIcon from 'js/design_system/icons/warning.svg';

import type { PaymentProblemAlertUnibrowProps } from './types';

export default function PaymentProblemAlertUnibrow({
  trigger,
  days,
}: PaymentProblemAlertUnibrowProps) {
  const dismissibleName = 'PaymentProblemAlertUnibrow';

  const handleClick = () => {
    if (trigger === 'paypal_past_due') {
      window.open('https://www.paypal.com/signin', '_blank');
    } else {
      window.location.href = routes.settings_path({
        anchor: 'premium-subscription',
        feature: 'payment_problem_alert',
        trigger: 'unibrow',
      });
    }
  };

  let text;
  switch (trigger) {
    case 'cc_expiring':
      text = days
        ? `Update your credit card to keep enjoying Premium. It expires in ${days} ${pluralize(
            'day',
            days,
          )}`
        : 'Update your credit card to keep enjoying Premium. It expires soon';
      break;
    case 'stripe_past_due':
    case 'paypal_past_due':
      text = 'Your payment was declined—update now to keep your Premium access';
      break;
  }

  const icon = trigger === 'cc_expiring' ? <InfoIcon /> : <WarningIcon />;

  return (
    <Unibrow
      variant="alert"
      dismissibleName={dismissibleName}
      text={text}
      primaryButton={{
        text: 'Update Payment',
        onClick: handleClick,
        trackClick: {
          source: 'payment_problem_alerts_unibrow',
        },
      }}
      icon={icon}
    />
  );
}
